import Vue from 'vue'
import 'carbon-components/css/carbon-components.css'

import {
  CvButton,
  CvSelect,
  CvSelectOption,
  CvDataTableCell,
  CvTextArea,
  CvTextInput,
  CvDatePicker,
  CvTab,
  CvTabs,
  CvCheckbox,
  CvRadioGroup,
  CvSkeletonText,
  CvRadioButton,
  CvForm,
  CvSideNav,
  CvInlineNotification,
  CvButtonSkeleton,
  CvNumberInput,
  CvDataTableSkeleton,
  CvLoading,
  CvTooltip,
  CvList,
  CvListItem,
} from '@carbon/vue/src/index'

Vue.component(CvButton.name, CvButton)
Vue.component(CvSelect.name, CvSelect)
Vue.component(CvSelectOption.name, CvSelectOption)
Vue.component(CvDataTableCell.name, CvDataTableCell)
Vue.component(CvTextArea.name, CvTextArea)
Vue.component(CvTextInput.name, CvTextInput)
Vue.component(CvDatePicker.name, CvDatePicker)
Vue.component(CvTab.name, CvTab)
Vue.component(CvTabs.name, CvTabs)
Vue.component(CvCheckbox.name, CvCheckbox)
Vue.component(CvRadioGroup.name, CvRadioGroup)
Vue.component(CvSkeletonText.name, CvSkeletonText)
Vue.component(CvRadioButton.name, CvRadioButton)
Vue.component(CvForm.name, CvForm)
Vue.component(CvSideNav.name, CvSideNav)
Vue.component(CvSideNav.name, CvSideNav)
Vue.component(CvInlineNotification.name, CvInlineNotification)
Vue.component(CvButtonSkeleton.name, CvButtonSkeleton)
Vue.component(CvNumberInput.name, CvNumberInput)
Vue.component(CvDataTableSkeleton.name, CvDataTableSkeleton)
Vue.component(CvLoading.name, CvLoading)
Vue.component(CvTooltip.name, CvTooltip)
Vue.component(CvList.name, CvList)
Vue.component(CvListItem.name, CvListItem)
